import { CalendarEvent } from 'angular-calendar';
import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { Dependencies } from '../../../store';
import { pluck } from '../../../store.decorator';
import { PayloadAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { UserService } from '../../../user/user.service';
import { ScheduleItem } from '../models/schedule.model';

import {
    ActionType,
    RootInitAction,
    rootInitResult,
    RootReloadAction,
    rootReloadResult,
} from './calendar.action';
import { retrieveEvents } from './calendar.function';
import { RootState } from './calendar.state';

export interface ChainGroup<TPayload> {
    root: TPayload;

    // view?: CalendarView;
    // viewDate?: Date;
    startDate?: Date;
    endDate?: Date;
    events?: ScheduleItem[];
    calendarEvents?: Array<CalendarEvent<ScheduleItem>>;
    manager?: User;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const rootInit = (
    action: ActionsObservable<PayloadAction<ActionType, RootInitAction>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.COACHING_CALENDAR__INIT),
        switchMap((act) => {
            const grp: ChainGroup<RootInitAction> = { root: act.payload };
            const service = deps.injector.get<UserService>(UserService);

            return of(null).pipe(
                switchMap(() => service.retrieve(act.payload.managerId)),
                // eslint-disable-next-line no-return-assign
                tap((ret) => (grp.manager = ret)),
                map(() =>
                    rootInitResult(
                        {
                            managerId: grp.root.managerId,
                            manager: grp.manager,
                        },
                        act.storePath,
                    ),
                ),
                catchError((e) => {
                    console.log(e);
                    return of(
                        rootInitResult({ ...act.payload }, act.storePath),
                    );
                }),
            );
        }),
    );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const rootReload = (
    action: ActionsObservable<PayloadAction<ActionType, RootReloadAction>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.COACHING_CALENDAR__RELOAD),
        switchMap((act) => {
            const rootState = pluck<RootState>(state.value, act.storePath);
            const grp: ChainGroup<RootReloadAction> = {
                root: act.payload,
                // view: rootState.view,
                // viewDate: rootState.startDate,
                startDate: rootState.startDate,
                endDate: rootState.endDate,
            };

            return of(null).pipe(
                retrieveEvents(deps, grp, act.payload.performerId),
                map(() =>
                    rootReloadResult(
                        {
                            performerId: grp.root.performerId,
                            view: grp.root.view,
                            viewDate: grp.root.viewDate,
                            // grp.view,
                            // grp.viewDate,
                            // view,
                            // viewDate,
                            // grp.startDate,
                            // grp.endDate,
                            events: grp.events,
                            calendarEvents: grp.calendarEvents,
                        },
                        act.storePath,
                    ),
                ),
                catchError((e) => {
                    console.log(e);
                    return of(
                        rootReloadResult({ ...act.payload }, act.storePath),
                    );
                }),
            );
        }),
    );

export default [rootInit, rootReload];
